import executeRequest from "Infrastructure/WebClient";
import * as RequestTypes from "Application/RequestTypes";
import {
  PaymentPlan,
  PaymentPlanEntity,
} from "Domain/PaymentPlan/Entity/PaymentPlan";
import { CreatePaymentPlanRequest } from "Domain/PaymentPlan/Dto/CreatePaymentPlanRequest";
import { getCurrentUserData } from "Application/User/UserService";
import moment from "moment";

export async function getPaymentPlan(id: string) {
  return executeRequest<PaymentPlan>(RequestTypes.PAYMENT_PLAN_DETAILS, [], {
    id: id,
  }).then((res) => {
    return res;
  });
}

export async function createPaymentPlan(
  createPaymentPlanRequest: CreatePaymentPlanRequest
) {
  return executeRequest(
    RequestTypes.CREATE_PAYMENT_PLAN,
    createPaymentPlanRequest
  );
}

export async function signPaymentPlanContract(id: string, signature: string) {
  return executeRequest(RequestTypes.SIGN_PAYMENT_PLAN_CONTRACT, {
    publicId: id,
    signature: signature,
  });
}

export async function sendPaymentPlanToDebtor(id: string) {
  return executeRequest(
    RequestTypes.PAYMENT_PLAN_SEND_TO_DEBTOR,
    {},
    { id: id }
  );
}

// ------------------- Public Actions -----------------------

export async function getPaymentPlanPublic(token: string) {
  return executeRequest<PaymentPlan>(
    RequestTypes.PAYMENT_PLAN_DETAILS_PUBLIC,
    [],
    {
      token: token,
    }
  ).then((res) => {
    return res;
  });
}

export async function signPaymentPlanContractPublic(
  token: string,
  signature: string
) {
  return executeRequest(RequestTypes.SIGN_PAYMENT_PLAN_CONTRACT_PUBLIC, {
    publicToken: token,
    signature: signature,
  });
}

// ------------------- Secured Payment Plan -----------------------

export function displaySessionsSection(paymentPlan: PaymentPlan) {
  const currentUser = getCurrentUserData();
  const paymentPlanEntity = new PaymentPlanEntity(paymentPlan);
  const nextPayOut = paymentPlanEntity.getNextSecuredPayout();

  if (
    nextPayOut &&
    (currentUser.isUserCreditor() || currentUser.isUserInternal())
  ) {
    return {
      display: true,
      isActive: moment(nextPayOut.sessionLimitDate) < moment(),
      nextSession: nextPayOut.sequence,
    };
  }

  return {
    display: false,
    isActive: false,
    nextSession: 1,
  };
}

export async function triggerNextSession(id: string) {
  return executeRequest(RequestTypes.PAYMENT_PLAN_SECURED_NEXT_SESSION, [], {
    id: id,
  });
}
